import request from "@/utils/request";

/**
 * 기본/기존 사이드바 메뉴 목업 데이터
 */
export const MOCK_MENU_LIST = [
  {
    name: "Home",
    path: "/scm/home",
    icon: "home-circle",
    color: "linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)",
    category: "홈",
    title: "Home",
    programId: "HOME",
    breadcrumb: ["SAMWOO ERP", "홈"],
  },
  // {
  //   name: "주문현황",
  //   path: "/scm/OrderList",
  //   icon: "cube-outline",
  //   color: "linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)",
  //   category: "영업관리",
  //   title: "주문현황",
  //   programId: "SCM101",
  //   breadcrumb: ["SAMWOO ERP", "영업관리", "주문현황"],
  // },
  // {
  //   name: "출고일보",
  //   path: "/scm/ShipmentList",
  //   icon: "clipboard-check",
  //   color: "linear-gradient(135deg, #10B981 0%, #047857 100%)",
  //   category: "출고관리",
  //   title: "출고일보",
  //   programId: "SCM102",
  //   breadcrumb: ["SAMWOO ERP", "출고관리", "출고일보"],
  // },
  // {
  //   name: "미납현황",
  //   path: "/scm/UndeliveredList",
  //   icon: "cash-multiple",
  //   color: "linear-gradient(135deg, #F43F5E 0%, #BE123C 100%)",
  //   category: "출고관리",
  //   title: "미납현황",
  //   programId: "SCM103",
  //   breadcrumb: ["SAMWOO ERP", "출고관리", "미납현황"],
  // },
  // {
  //   name: "연체료현황",
  //   path: "/scm/LateFeeList",
  //   icon: "card-bulleted",
  //   color: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
  //   category: "영업관리",
  //   title: "연체료현황",
  //   programId: "SCM104",
  //   breadcrumb: ["SAMWOO ERP", "영업관리", "연체료현황"],
  // },
  // {
  //   name: "NCR현황",
  //   path: "/scm/NCRList",
  //   icon: "chart-box",
  //   color: "linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)",
  //   category: "품질관리",
  //   title: "NCR현황",
  //   programId: "SCM105",
  //   breadcrumb: ["SAMWOO ERP", "품질관리", "NCR현황"],
  // },
  {
    name: "재고조회",
    path: "/smm/SM303",
    icon: "clipboard-list",
    color: "linear-gradient(135deg, #06B6D4 0%, #0E7490 100%)",
    category: "수불관리",
    title: "재고조회(영업사원용)",
    programId: "SM303",
    breadcrumb: ["SAMWOO ERP", "수불관리", "재고조회(영업사원용)"],
  },
];

/**
 * 경로(path)로 메뉴 정보 조회
 * @param {string} path - 라우트 경로
 * @param {Array} [menuList] - 메뉴 목록
 * @returns {Object|null}
 */
export function getMenuByPath(path, menuList) {
  const list = menuList && menuList.length > 0 ? menuList : MOCK_MENU_LIST;
  return list.find((m) => m.path === path) || null;
}

/**
 * [목업 함수] 사용자 아이디(userId)로 메뉴 목록을 비동기 조회
 * DB 연결 파라미터 및 API가 준비되면 아래 실제 호출부로 교체하시면 됩니다.
 * 
 * @param {string} userId - 사용자 아이디
 * @returns {Promise<Array>} 메뉴 리스트
 */
export async function getUserMenuList(userId) {
  console.log(`[API Mock] 사용자 아이디(${userId})로 메뉴 목록을 요청합니다.`);

  // 1. 목업 비동기 지연 시뮬레이션 (필요시 지연 시간 조절 가능)
  return new Promise((resolve) => {
    setTimeout(() => {
      // 사용자 아이디에 따른 분기 테스트가 필요한 경우 여기서 커스텀 가능
      // 예: if (userId === 'admin') ...
      console.log(`[API Mock] 사용자 아이디(${userId}) 메뉴 데이터 로드 완료:`, MOCK_MENU_LIST);
      resolve([...MOCK_MENU_LIST]);
    }, 100);
  });

  /*
  // ==============================================================
  // [추후 실제 DB / API 연결 템플릿]
  // 파라미터를 알려주시면 아래 형태로 즉시 전환할 수 있습니다.
  // ==============================================================
  return request({
    url: "/api/menu/list", // 또는 /api/ExecuteDataSet 등
    method: "post",
    data: {
      userId: userId,
      // 추가 파라미터 전달
    },
    timeout: 30000,
  }).then((res) => {
    // 서버 응답 데이터를 사이드바 포맷({ name, path, icon })으로 가공하여 반환
    return res.data;
  });
  */
}
